import { Component } from '@angular/core';
import { NavController, AlertController } from 'ionic-angular';
import { ControlEquiposPage } from '../control-equipos/control-equipos';
import { RegresoViajePage } from '../regreso-viaje/regreso-viaje';
import { LoginPage } from '../login/login';
import { DataProvider } from '../../providers/data/data';
import { Platform } from 'ionic-angular';

//import { ControlEquiposDetallePage, ControlEquiposDetalleParams } from '../control-equipos-detalle/control-equipos-detalle';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  public labels = {
    regresos: "",
    controles: ""
  }

  public bindData: { regresos: number, controles: number} = { regresos: 0, controles: 0};

  constructor(public navCtrl: NavController, public data: DataProvider, public alertCtrl: AlertController,
    public platform: Platform) {

    this.data.getMaestros().subscribe();
    this.data.getViajes().subscribe();

  }

  public logOut(){
    const alert = this.alertCtrl.create({
      title: 'Cerrar Sesión',
      subTitle: '¿Está seguro de que desea cerrar sesión?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            console.log('Cancelado');
            // No hace nada
          }
        },
        {
          text: 'Cerrar Sesión',
          handler: () => {
            console.log('Sesión cerrada');
            this.data.logOut();
            this.platform.exitApp();
            this.navCtrl.setRoot(LoginPage);
          }
        }
      ]
    });
    alert.present();
  }

  public traerSincroPendiente(){
    this.data.getRegresosNoSync().subscribe(r => {
      this.bindData.regresos = r;
      if(this.bindData.regresos>0){
        this.labels.regresos = "Regresos sin Sincronizar: " + this.bindData.regresos
      } else {
        this.labels.regresos = "";
      }
    });
    this.data.getControlesNoSync().subscribe(c => {
      console.log(c);
      this.bindData.controles = c;
      if(this.bindData.controles>0){
        this.labels.controles = "Controles sin Sincronizar: " + this.bindData.controles
      } else {
        this.labels.controles = "";
      }
    });
  }

  ionViewDidEnter(){
    console.log("Entro a HOME");
    this.traerSincroPendiente();
  }

  goControlEquipos() {
    this.navCtrl.push(ControlEquiposPage);
  }

  goRegresoViaje() {
    this.navCtrl.push(RegresoViajePage);
  }

  ignorar(){
    this.data.removerDatosPendientes();

    this.labels.regresos = "";
    this.labels.controles = "";

  }
  sincronizar(){
    /*if(this.data.isOffline){
      const alert = this.alertCtrl.create({
        title: 'Error',
        message: 'No hay Conexión',
        buttons: ['OK']
      });
      alert.present();
      return;
    }*/
    this.data.sincronizarDatos().subscribe(e => {
      let grabacion  = e;
      console.log("Resultado Grabacion",grabacion);
      if(grabacion){
        this.traerSincroPendiente();
        this.data.getViajes().subscribe();
      } else {
        const alert = this.alertCtrl.create({
          title: 'Error',
          subTitle: 'Falló la Sincronización',
          buttons: ['OK']
        });
        alert.present();
      }
    });

    this.data.sincronizarDatosControlEquipo().subscribe(e => {
      let grabacion  = e;
      console.log("Resultado Grabacion",grabacion);
      if(grabacion){
        this.traerSincroPendiente();
        this.data.getMaestros().subscribe();
      } else {
        const alert = this.alertCtrl.create({
          title: 'Error',
          subTitle: 'Falló la Sincronización',
          buttons: ['OK']
        });
        alert.present();
      }
    });
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts